module.exports = __webpack_public_path__ + "img/galerie-rive-nord.736592d5.png";